import React from 'react';

import Meta from './../components/Meta';
import useMetaTags from './../hooks/useMetaTags';

import Header from './../components/header';
import Footer from './../components/footer';

function PrivacyPolicy() {
  useMetaTags();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        <p className="mb-8"><strong>Effective Date:</strong> March 18, 2025</p>

        <p className="mb-6">
          Thank you for using <strong>AuLedger</strong> ("the App"). This Privacy Policy explains how we handle any personal information we may access or store in connection with your use of the App.
        </p>

        {/* Section 1 */}
        <h2 className="text-xl font-bold mt-8 mb-4">1. Data We Do Not Collect</h2>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>We do <strong>not</strong> collect or store any personal information.</li>
          <li>We do <strong>not</strong> use analytics tools or third-party data collection.</li>
          <li>We do <strong>not</strong> share personally identifiable user data with third parties.</li>
        </ul>

        {/* Section 2 */}
        <h2 className="text-xl font-bold mt-8 mb-4">2. Advertising</h2>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>The free version of our app displays advertisements via <strong>Google AdMob</strong>.</li>
          <li>AdMob may collect device info (IP address, device model, advertising identifiers).</li>
          <li>See <a href="https://policies.google.com/privacy" target="_blank" className="text-blue-600 hover:underline">Google's Privacy Policy</a>.</li>
          <li>You can opt out of personalized ads via **Google Settings**.</li>
          <li>Upgrading to <strong>Premium</strong> removes all ads.</li>
        </ul>

        {/* Section 3 */}
        <h2 className="text-xl font-bold mt-8 mb-4">3. Premium Features and Subscriptions</h2>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Premium removes ads and unlocks <strong>historical price charts</strong>.</li>
          <li>Payments are processed by <strong>Apple</strong> through the <strong>App Store</strong>.</li>
          <li>We do <strong>not</strong> store your payment information.</li>
          <li>Users who purchased the app before <strong>March 31, 2025</strong> receive automatic Premium access.</li>
        </ul>

        {/* Section 4 */}
        <h2 className="text-xl font-bold mt-8 mb-4">4. Local Data Storage</h2>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Your <strong>gold portfolio</strong> is stored <strong>locally</strong> on your device.</li>
          <li>Photos are stored <strong>locally</strong> and are <strong>not</strong> uploaded.</li>
          <li>Deleting the app removes all local data.</li>
        </ul>

        {/* Section 5 */}
        <h2 className="text-xl font-bold mt-8 mb-4">5. Contact Us</h2>
        <p className="mb-6">
          If you have any questions, email us at 📧 <a href="mailto:contact@auledgerapp.com" className="text-blue-600 hover:underline">contact@auledgerapp.com</a>
        </p>

        {/* Last Updated */}
        <p className="mt-10 mb-6"><strong>Last Updated:</strong> March 18, 2025</p>
        <p className="mb-6">
          By using <strong>AuLedger</strong>, you agree to this Privacy Policy. If you do <strong>not</strong> agree, please <strong>discontinue use</strong> of the App.
        </p>
      </div>

      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
